import { Routes, Route } from 'react-router-dom';
import { HomePage } from '@/pages/HomePage';
import { DraftsPage } from '@/pages/DraftsPage';
import { DraftDetailPage } from '@/pages/DraftDetailPage';
import { CatalogPage } from '@/pages/CatalogPage';
import { CatalogDetailPage } from '@/pages/CatalogDetailPage';
import { MenuItemsCleanupPage } from '@/pages/MenuItemsCleanupPage';
import { EditMenuItemsPage } from '@/pages/EditMenuItemsPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { UsagePage } from '@/pages/UsagePage';
import { IdentityLabelPage } from '@/pages/IdentityLabelPage';
import { AuthCallbackPage } from '@/pages/AuthCallbackPage';
import { SignedOutPage } from '@/pages/SignedOutPage';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/drafts" element={<DraftsPage />} />
      <Route path="/drafts/:id" element={<DraftDetailPage />} />
      <Route path="/catalog" element={<CatalogPage />} />
      <Route path="/catalog/new" element={<CatalogDetailPage />} />
      <Route path="/catalog/:id" element={<CatalogDetailPage />} />
      <Route path="/menu-items/cleanup" element={<MenuItemsCleanupPage />} />
      <Route path="/menu-items/edit" element={<EditMenuItemsPage />} />
      <Route path="/identity/label" element={<IdentityLabelPage />} />
      <Route path="/usage" element={<UsagePage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/auth/signed-out" element={<SignedOutPage />} />
    </Routes>
  );
}
